export default {
  football: "⚽",
  basketball: "🏀",
  slotMachine: "🎰",
  gameDie: "🎲",
  bowling: "🎳"
};
